import React, { Fragment, useState, useEffect, useContext } from "react";
import { useLocation } from "react-router-dom";
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import {
    Input,
    Row,
    Col,
  } from "reactstrap";
  import { appContext } from "../../../Utils/context";

function Card_view() {
  const location = useLocation();
  const [path, setPath] = useState('');
  const { view, setView, user } = useContext(appContext);

  useEffect(() => {
    const currentPath = location.pathname;
    const parts = currentPath.split('/records/');
    const lastPart = parts.length > 1 ? parts[1] : '';
    setPath(lastPart)
    // Do whatever you need with the currentPath
  },[location]);

  return (
    <Fragment>
        {(user?.allow_record_page && path) && <TransitionGroup>
        <CSSTransition
            component="div"
            classNames="TabsAnimation"
            appear={true}
            timeout={0}
            enter={false}
            exit={false}
        >
          <Row className="pe-0 ps-2">
           <Col md="12">
             <Input
               type="select"
               bsSize="sm"
               value={view || ""}
               onChange={(e) => {
                setView(e.target.value);
               }}
             >
               <option value='list' className="bg-light text-secondary">
                 List View
               </option>
               <option  value='card' className="bg-light text-secondary">Card View</option>
             </Input>
           </Col>
           </Row>
           </CSSTransition>
           </TransitionGroup>}
           </Fragment>
  )
}

export default Card_view